import React from 'react';

const EquipmentModelsContext = React.createContext({});

export default EquipmentModelsContext;
